import { EnumZboPostaveniSubjektu } from '../api';
export const enumZboPostaveniSubjektu = Object.keys(EnumZboPostaveniSubjektu);
export const getEnumZboPostaveniSubjektuCaption = (typ) => {
    switch (typ) {
        case EnumZboPostaveniSubjektu.INVESTOR:
            return 'Investor';
        case EnumZboPostaveniSubjektu.KONTAKT:
            return 'Kontaktní osoba';
        case EnumZboPostaveniSubjektu.NAJEMCE:
            return 'Nájemce';
        case EnumZboPostaveniSubjektu.PODATEL:
            return 'Podatel žádosti';
        case EnumZboPostaveniSubjektu.PODEPISUJICI:
            return 'Podepisující osoba';
        case EnumZboPostaveniSubjektu.PRONAJIMATEL:
            return 'Pronajímatel';
        case EnumZboPostaveniSubjektu.ZADATEL:
            return 'Žadatel';
        case EnumZboPostaveniSubjektu.ZASTUPCE:
            return 'Oprávněný zástupce';
        case EnumZboPostaveniSubjektu.ZHOTOVITEL:
            return 'Zhotovitel';
        case EnumZboPostaveniSubjektu.ZODPOVEDNY:
            return 'Zodpovědná osoba';
        default:
            return `_${typ}`;
    }
};
export const getEnumZboPostaveniSubjektuItems = () => {
    return enumZboPostaveniSubjektu.map(t => ({ id: t, name: getEnumZboPostaveniSubjektuCaption(t) })).sort((a, b) => a.name.localeCompare(b.name));
};
//# sourceMappingURL=ZboPostaveniSubjektuCaption.js.map